import {ApiStatus, Favorite} from '../../models';
import {FavoriteAction, FavoriteActionTypes,} from '../actions/favoriteActions';

export const initialFavoriteState: IFavoriteState = {
  loadingStatus: ApiStatus.LOADING,
  creatingStatus: null,
  updatingStatus: null,
  deletingStatus: ApiStatus.LOADED,
  results: [],
};

export interface IFavoriteState {
  loadingStatus: ApiStatus;
  creatingStatus: ApiStatus | null;
  updatingStatus: ApiStatus | null;
  deletingStatus: ApiStatus;
  results: Favorite[];
}

export default function favoriteReducer(
  state: IFavoriteState = initialFavoriteState,
  action: FavoriteAction
): IFavoriteState {
  switch (action.type) {
    case FavoriteActionTypes.LOAD_FAVORITES:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING,
      };
    case FavoriteActionTypes.LOADED_FAVORITES:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADED,
        results: action.payload.result,
      };
    case FavoriteActionTypes.LOADING_FAVORITES_FAILED:
      return {
        ...state,
        loadingStatus: ApiStatus.FAILED,
      };
    case FavoriteActionTypes.CREATE_FAVORITE:
      return {
        ...state,
        creatingStatus: ApiStatus.LOADING,
      };
    case FavoriteActionTypes.CREATED_FAVORITE:
      const {result} = action.payload;
      let results: any[] = [];

      if (!!result) {
        results = [
          ...state.results,
          result,
        ];
      }
      return {
        ...state,
        creatingStatus: ApiStatus.LOADED,
        results,
      };
    case FavoriteActionTypes.CREATING_FAVORITE_FAILED:
      return {
        ...state,
        creatingStatus: ApiStatus.FAILED,
      }
    case FavoriteActionTypes.DELETE_FAVORITE:
      return {
        ...state,
        deletingStatus: ApiStatus.LOADING,
      }
    case FavoriteActionTypes.DELETED_FAVORITE:
      return {
        ...state,
        results: state.results?.filter(f => f.uid !== action.payload) || [],
        deletingStatus: ApiStatus.LOADED,
      }
    case FavoriteActionTypes.DELETING_FAVORITE_FAILED:
      return {
        ...state,
        deletingStatus: ApiStatus.FAILED,
      }

    default:
      return state;
  }
}
